/**
 * package: com.inq.ui
 * class: StyleSheet
 * root Object
 * @constructor
 */
com.inq.ui.StyleSheet = function() {
	this.styleNames = { };
};
$hxClasses.registerClass(com.inq.ui.StyleSheet, "com.inq.ui.StyleSheet");

/**
 * transform
 *
 * $type TFun([{ name => formatObject, t => TDynamic(null), opt => false }],TDynamic(null))
 * @public
 * @this com.inq.ui.StyleSheet
 * @param {null}  formatObject 
 * @return {null}
 */
com.inq.ui.StyleSheet.prototype.transform = function(formatObject) {
	return null;
};


/**
 * setStyle
 *
 * $type TFun([{ name => styleName, t => TInst(String,[]), opt => false },{ name => styleObject, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * @public
 * @this com.inq.ui.StyleSheet
 * @param {string}  styleName 
 * @param {null}  styleObject 
 * @return {void}
 */
com.inq.ui.StyleSheet.prototype.setStyle = function(styleName,styleObject) {
	/** @type {string} */
	var s = "";
	if(!js.Boot.__instanceof(styleObject,String)) {
		var /** @type {number} */ i;
		/** @type {Array} */
		var keyz = Reflect.fields(styleObject);
		var /** @type {number} */ _g1 = 0, /** @type {number} */ _g = keyz.length;
		while(_g1 < _g) {
			var /** @type {number} */ i1 = _g1++;
			var /** @type {string} */ name = keyz[i1];
			/** @type {string} */
			var fixedname = name;
			switch(name.toLowerCase()) {
				case "fontfamily":
					fixedname = "font-family";
					break;
				case "fontsize":
					fixedname = "font-size";
					break;
				case "fontweight":
					fixedname = "font-weight";
					break;
				case "fontstyle":
					fixedname = "font-style";
					break;
				case "fontsizeadjust":
					fixedname = "font-size-adjust";
					break;
				case "fontstretch":
					fixedname = "font-stretch";
					break;
				case "fontvariant":
					fixedname = "font-variant";
					break;
				case "lineheight":
					
					fixedname = "line-height";
					break;
				case "textalign":
					
					fixedname = "text-align";
					break;
				case "textdecoration":
					fixedname = "text-decoration";
					break;
				case "textindent":
					fixedname = "text-indent";
					break;
				case "textshadow":
					fixedname = "text-shadow";
					break;
				case "texttransform":
					fixedname = "text-transform";
					break;
				default:
					fixedname = name;
			}
			/** @type {string} */
			var valuz = styleObject[name];
			s += fixedname + ":" + Std.string(valuz) + ";";
		}
	} else s = styleObject;
	
	this.styleNames[styleName] = s;
};


/**
 * parseCSS
 *
 * $type TFun([{ name => CSSText, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * @public
 * @this com.inq.ui.StyleSheet
 * @param {string}  CSSText 
 * @return {void}
 */
com.inq.ui.StyleSheet.prototype.parseCSS = function(CSSText) {
};


/**
 * getStyle
 *
 * $type TFun([{ name => styleName, t => TInst(String,[]), opt => false }],TDynamic(null))
 * @public
 * @this com.inq.ui.StyleSheet
 * @param {string}  styleName 
 * @return {null}
 */
com.inq.ui.StyleSheet.prototype.getStyle = function(styleName) {
	/** @type {?string} */
	var style = this.styleNames[styleName];
	return style;
};


/**
 * clear
 *
 * $type TFun([],TEnum(Void,[]))
 * @public
 * @this com.inq.ui.StyleSheet
 * @return {void}
 */
com.inq.ui.StyleSheet.prototype.clear = function() {
	this.styleNames = { };
};

/** @type {null} */
com.inq.ui.StyleSheet.prototype.styleNames = null;
/** @type {com.inq.ui.StyleSheet} */
com.inq.ui.StyleSheet.prototype.__class__ = com.inq.ui.StyleSheet;
